<template>
  <div class="home-block">
    <home-block-title
      title="学院视频"
      linkText="最新动态 前沿讯息"
      :link="{
        path: '/commonMore',
        query: {
          commonMoreName: '学院视频',
          showType: 'video',
          activeMenu: '学院视频'
        }
      }"
    />
    <div class="list">
      <swiper ref="mySwiper" class="swiper-video" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in list" :key="index">
          <iframe
            :src="item.videoUrl"
            style="width: 100%; height: 450px"
            frameborder="0"
            allowfullscreen
          />
          <div class="name">
            {{ item.videoName }}
          </div>
        </swiper-slide>

        <div
          id="swiper-pagination-video"
          class="swiper-pagination"
          slot="pagination"
        />
      </swiper>
    </div>
  </div>
</template>

<script>
  import homeBlockTitle from "./home-block-title.vue"
  import { getVideo } from "@/api/home"

  export default {
    components: { homeBlockTitle },

    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    data() {
      return {
        list: [],
        swiperOptions: {
          loop: true,
          pagination: {
            el: "#swiper-pagination-video",
            dynamicBullets: true
            // bulletActiveClass: "my-bullet-active"
          }
          // autoplay: {
          //   delay: 10000,
          //   disableOnInteraction: false
          // }
        }
      }
    },
    created() {},
    mounted() {
      this.load()
    },
    methods: {
      load() {
        this.request()
      },
      request() {
        const sendData = {
          menuId: 2,
          pageNum: 1,
          pageSize: 9
        }
        getVideo(sendData).then((res) => {
          let list = res.data.data || []
          list = list.slice(0, 4)
          this.list = list
          this.swiper.init()
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .list {
    display: block;
    height: auto;
  }
  .swiper-video {
    height: 500px;
  }
  .name {
    font-size: 30px;
    font-weight: 600;
    text-align: left;
    color: #292929;
    line-height: 38px;
    margin-top: 5px;
    max-width: calc(100% - 115px);
    overflow: hidden;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号 */
  }

  #swiper-pagination-video {
    right: -60px;
    bottom: 0px;
    left: auto;

    ::v-deep(.swiper-pagination-bullet-active) {
      width: 15px;
      height: 15px;
      background-color: #000;
    }
    ::v-deep(.swiper-pagination-bullet) {
      width: 15px;
      height: 15px;
    }
  }
</style>
